<template>
  <el-dialog :title="$t('addAMenu.add')" :visible.sync="dialogVisible" width="70%">
    <el-form ref="form" :model="addAMenuInfo" label-width="120px">
      <el-form-item :label="$t('addAMenu.menuName')" prop="hktName"
        :rules="[{ required: true, message: $t('addAMenu.menuNameRequired') }]">
        <el-input v-model="addAMenuInfo.hktName" :placeholder="$t('addAMenu.inputMenuName')" />
      </el-form-item>
      <el-form-item :label="$t('addAMenu.logo')" prop="hktIcon"
        :rules="[{ required: true, message: $t('addAMenu.logoRequired') }]">
        <upload-image ref="uploadImage" :image-count="1" @notifyUploadCoverImage="handleUploadImage" />
      </el-form-item>
      <el-form-item :label="$t('addAMenu.menuDesc')" prop="hktDesc">
        <el-input v-model="addAMenuInfo.hktDesc" :placeholder="$t('addAMenu.inputMenuDesc')" />
      </el-form-item>
      <el-form-item :label="$t('addAMenu.label')" prop="label">
        <el-input v-model="addAMenuInfo.label" :placeholder="$t('addAMenu.inputLabel')" />
      </el-form-item>
      <el-form-item :label="$t('addAMenu.sort')" prop="seq"
        :rules="[{ required: true, message: $t('addAMenu.sortRequired') }]">
        <el-input v-model="addAMenuInfo.seq" :placeholder="$t('addAMenu.inputSort')" />
      </el-form-item>
      <el-form-item :label="$t('addAMenu.isShow')" prop="isShow"
        :rules="[{ required: true, message: $t('addAMenu.showStatusRequired') }]">
        <el-select v-model="addAMenuInfo.isShow" :placeholder="$t('addAMenu.selectShowStatus')" style="width:100%">
          <el-option :label="$t('common.yes')" value="Y" />
          <el-option :label="$t('common.no')" value="N" />
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        {{ $t('common.cancel') }}
      </el-button>
      <el-button type="primary" @click="saveHousekeepingTypeInfo">
        {{ $t('common.save') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveProductMenu } from '@/api/admin/shopProductType/shopProductTypeApi'
import UploadImage from '@/components/system/UploadImage'

export default {
  name: 'AddAMenu',
  components: {
    UploadImage
  },
  data() {
    return {
      dialogVisible: false,
      addAMenuInfo: {
        hktId: '',
        hktName: '',
        hktIcon: '',
        hktDesc: '',
        label: '',
        seq: '',
        url: '#',
        skipType: '3',
        isShow: '',
        typeCd: '2002'
      }
    }
  },
  methods: {
    open(data = {}) {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.resetFields()
        this.addAMenuInfo = {
          ...this.addAMenuInfo,
          ...data
        }
        if (data.hktIcon) {
          this.$refs.uploadImage.setImages([data.hktIcon])
        } else {
          this.$refs.uploadImage.clearImages()
        }
      })
    },
    handleUploadImage(photos) {
      this.addAMenuInfo.hktIcon = photos && photos.length > 0 ? photos[0] : ''
    },
    async saveHousekeepingTypeInfo() {
      try {
        const valid = await this.$refs.form.validate()
        if (!valid) return

        await saveProductMenu(this.addAMenuInfo)
        this.$message.success(this.$t('common.saveSuccess'))
        this.dialogVisible = false
        this.$emit('success')
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>